/**
 * Mapping mots-clés → catégorie de plan générique pour le QCM DrillSurvival.
 *
 * Extrait dans son propre module (vs inline dans DrillSurvival.tsx) parce que
 * (1) ESLint `react-refresh/only-export-components` warn quand un fichier
 * composant exporte aussi des fonctions utilitaires, (2) ça permet de tester
 * le mapping isolément sans monter le composant React.
 *
 * P2 vague C'.3 (B6) — élargissement vs MVP1.0 :
 *  - Couvre ~70-80% des plans réels de `data/openings/**\/*.pgn` (vs ~15-20%
 *    avant)
 *  - Ordre des branches : du PLUS SPÉCIFIQUE (sacrifice/mat/échange/centre)
 *    au PLUS GÉNÉRIQUE (développement). Le développement est le fallback
 *    default car beaucoup de plans français mentionnent à la fois
 *    "développement" et un concept dominant (sacrifice, centre…).
 *
 * Avant ce fix, DrillSurvival loggait "Tentative notée comme partielle"
 * sur la majorité des positions, frustrant pédagogiquement (Léon clique
 * 3 plans et voit toujours le même message). Bug B6 test Léon Galaxy Tab
 * 2026-05-17.
 */

export function mapPlanToGeneric(plan: string | null): number | null {
  if (!plan) return null;
  const lower = plan.toLowerCase();

  // Regex : `\b` au début seulement (préfixe de mot) ; la fin du préfixe
  // peut être suivie de n'importe quel suffixe (ex: "attaqu" → "attaque",
  // "attaquer", "attaque-roi"). Mots autonomes (ex: "mat" qui doit pas
  // matcher "mater") utilisent `\b` explicite après le mot.

  // 2 Attaque roi (concept fort : sacrifice/mat/attaque/initiative dominent)
  if (/\b(attaqu|aile-roi|aile roi|flanc-roi|flanc roi|sacrif|menac|initiati|press(?:ion|er)|mat\b|brise.* roi|cass.* roi)/i.test(lower)) return 2;

  // 3 Échange/simplification (concept structurel fort — finale, conversion)
  if (/\b(échang|echang|simplifi|finale|conver|paire de fous|fou\b)/i.test(lower)) return 3;

  // 1 Centre (mots-clés positionnels : majorité, rupture, structure, coups SAN centraux)
  if (/\b(centre\b|majorit|occup|contrôl|fermé|cassé|casser|symétri|romp|rupture|brèche|[cde][45]\b)/i.test(lower)) return 1;

  // 0 Développement (fallback default : tout plan d'ouverture sans concept
  // dominant identifié est probablement "développer + roquer")
  if (/\b(roqu|o-o\b|0-0|développ|harmonie|harmonieux|tempo\b|fianchetto|prépar)/i.test(lower)) return 0;

  return null;
}
